export default {"src":"/evde-internet/_next/static/media/Shape.f6aa8036.svg","height":30,"width":32};